import React from "react";
import { TrendingUp, Smile, Wrench, Wallet } from "lucide-react";

const Benefits = () => {
  const benefits = [
    {
      icon: TrendingUp,
      title: "Øk omsetning",
      description:
        "Gjester blir lenger når de kan lade telefonen. Lengre opphold betyr mer salg.",
    },
    {
      icon: Smile,
      title: "Forbedre kundeopplevelse",
      description:
        "Tilby en etterspurt tjeneste som gjør besøket mer behagelig for gjestene.",
    },
    {
      icon: Wrench,
      title: "Null arbeid",
      description:
        "Vi håndterer alt – installasjon, vedlikehold og support. Du trenger ikke løfte en finger.",
    },
    {
      icon: Wallet,
      title: "Ekstra inntekt",
      description:
        "Tjen penger på hver utleie. En enkel måte å øke inntektene på.",
    },
  ];

  return (
    <section
      id="benefits"
      className="py-24 md:py-32 bg-[#121212]"
      data-testid="benefits-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFD84D] mb-4 block">
            For bedrifter
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white font-['Outfit']">
            Fordeler for din virksomhet
          </h2>
        </div>

        {/* Benefits Bento Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`bg-[#0A0A0A] border border-white/5 rounded-2xl p-8 md:p-10 card-hover tracing-beam group ${
                index === 0 ? "md:row-span-2" : ""
              }`}
              data-testid={`benefit-${index + 1}`}
            >
              {/* Icon */}
              <div className="icon-wrapper mb-6 group-hover:shadow-[0_0_20px_rgba(255,216,77,0.3)] transition-all">
                <benefit.icon className="w-7 h-7 text-[#FFD84D]" />
              </div>

              {/* Content */}
              <h3 className="text-xl md:text-2xl font-semibold text-white mb-4 font-['Outfit']">
                {benefit.title}
              </h3>
              <p className="text-[#A1A1AA] leading-relaxed text-base md:text-lg">
                {benefit.description}
              </p>

              {/* Large card extra content */}
              {index === 0 && (
                <div className="mt-8 pt-8 border-t border-white/5">
                  <div className="flex items-center gap-4">
                    <div className="text-4xl font-bold text-[#FFD84D] font-['Outfit']">
                      30%
                    </div>
                    <p className="text-[#A1A1AA] text-sm">
                      gjennomsnittlig økning i oppholdstid hos våre partnere
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="btn-primary inline-flex items-center gap-2"
            data-testid="benefits-cta"
          >
            Start i dag – helt gratis
          </a>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
